import { createFileRoute } from "@tanstack/react-router";

import TermsPage from "@/landing/terms/page";

const SITE_URL = "https://diningmate.com.au";

export const Route = createFileRoute("/terms")({
    head: () => ({
        meta: [
            { title: "Terms of Service | DiningMate" },
            {
                name: "description",
                content:
                    "Review the DiningMate Terms of Service governing your use of our restaurant reservation platform.",
            },
            { property: "og:title", content: "Terms of Service | DiningMate" },
            {
                property: "og:description",
                content:
                    "Review the DiningMate Terms of Service governing your use of our restaurant reservation platform.",
            },
            { property: "og:url", content: `${SITE_URL}/terms` },
            { name: "robots", content: "noindex" },
        ],
        links: [{ rel: "canonical", href: `${SITE_URL}/terms` }],
    }),
    component: TermsPage,
});
